import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const PATH = "M -60 640 C 220 420, 420 780, 660 540 S 1010 140, 1260 250";
const STOPS = [0.52, 0.72, 0.9];
const EASE = [0.65, 0, 0.35, 1];
const TONES = {
  light: { main: "#BFD8EE", soft: "#DCE8F4", key: "#0085B3", fill: "#FFFFFF", dot: "#005EB8" },
  dark: { main: "rgba(191,216,238,0.38)", soft: "rgba(191,216,238,0.2)", key: "#8EC5EA", fill: "#05325F", dot: "#8EC5EA" },
};

const draw = (delay, duration) => ({
  hidden: { pathLength: 0, opacity: 0 },
  show: { pathLength: 1, opacity: 1, transition: { pathLength: { duration, delay, ease: EASE }, opacity: { duration: 0.4, delay } } },
});
const diamond = (x, y, s = 11) => `M ${x} ${y - s} L ${x + s} ${y} L ${x} ${y + s} L ${x - s} ${y} Z`;

export const MotionLines = ({ id, tone = "light", inView = false, style, className = "", testId }) => {
  const pathRef = useRef(null);
  const [keys, setKeys] = useState([]);
  const c = TONES[tone];
  useEffect(() => {
    const p = pathRef.current;
    if (!p) return;
    const len = p.getTotalLength();
    setKeys(STOPS.map((t) => { const pt = p.getPointAtLength(len * t); return [pt.x, pt.y]; }));
  }, []);
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.15 } } : { animate: "show" };

  return (
    <motion.svg viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice" style={style} initial="hidden" {...trigger}
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} aria-hidden="true" data-testid={testId}>
      <motion.path ref={pathRef} id={id} d={PATH} fill="none" stroke={c.main} strokeWidth="2" variants={draw(0.6, 2.8)} />
      <motion.path d="M -60 700 C 260 500, 460 840, 700 610 S 1040 230, 1260 330" fill="none" stroke={c.soft} strokeWidth="1.5" strokeDasharray="4 10" variants={draw(0.9, 3)} />
      <motion.circle cx="1030" cy="210" r="150" fill="none" stroke={c.soft} strokeWidth="1.5" variants={draw(1.2, 2.2)} />
      <motion.circle cx="1030" cy="210" r="92" fill="none" stroke={c.main} strokeWidth="1.5" strokeDasharray="2 8" variants={draw(1.4, 2)} />
      {keys.map(([x, y], i) => (
        <motion.path key={i} d={diamond(x, y)} fill={c.fill} stroke={c.key} strokeWidth="2" className="hidden sm:inline"
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          variants={{ hidden: { scale: 0 }, show: { scale: 1, transition: { delay: 1.6 + i * 0.5, type: "spring", stiffness: 260, damping: 14 } } }} />
      ))}
      <motion.g variants={{ hidden: { opacity: 0 }, show: { opacity: 1, transition: { delay: 3.2, duration: 0.8 } } }}>
        <circle r="6" fill={c.dot}>
          <animateMotion dur="11s" repeatCount="indefinite" keyPoints="0;1" keyTimes="0;1" calcMode="spline" keySplines="0.45 0 0.55 1">
            <mpath href={`#${id}`} />
          </animateMotion>
        </circle>
      </motion.g>
    </motion.svg>
  );
};
